import React, { createContext, ReactNode, useContext, useState } from 'react';

interface TradeModuleContextType {
  isTradeModuleModalOpen: boolean;
  setIsTradeModuleModalOpen?: (isOpen: boolean) => void; // made optional
  isConfirmTradeIntroOpen: boolean;
  setIsConfirmTradeIntroOpen?: (isOpen: boolean) => void; // made optional
}

export const TradeModuleContext = createContext<TradeModuleContextType>({
  isTradeModuleModalOpen: false,
  setIsTradeModuleModalOpen: undefined,
  isConfirmTradeIntroOpen: false,
  setIsConfirmTradeIntroOpen: undefined,
});

interface TradeModuleProviderProps {
  children: ReactNode;
}

export const TradeModuleProvider: React.FC<TradeModuleProviderProps> = ({
  children,
}) => {
  const [isTradeModuleModalOpen, setIsTradeModuleModalOpen] = useState(false);
  const [isConfirmTradeIntroOpen, setIsConfirmTradeIntroOpen] = useState(false);

  const value: TradeModuleContextType = {
    isTradeModuleModalOpen,
    setIsTradeModuleModalOpen,
    isConfirmTradeIntroOpen,
    setIsConfirmTradeIntroOpen,
  };

  return React.createElement(TradeModuleContext.Provider, { value }, children);
};

export const useTradeModuleContext = () => useContext(TradeModuleContext);
